<template>
  <div class="timeInterval">
    <div class="day-time-line" v-for="(item, index) in lineIndex">
      <div style="display: flex;justify-content: flex-start;margin-bottom: 10px">
        <el-checkbox-group v-model="item.weekDay" size="small">
          <el-checkbox-button v-for="week in item.week" :label="week.key" :disabled="week.disabled" :key="week.key" >{{week.key}}</el-checkbox-button>
        </el-checkbox-group>
        <div v-if="index !== 0"><i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removeTimeLine(index)"></i></div>
      </div>
      <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;width: 850px;">
        <el-time-picker is-range v-for="(weekTimeValue, weekTimeValueIndex) in item.weekTimeValue" :key="weekTimeValueIndex" v-model="weekTimeValue.key" size="small" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" format="HH:mm" value-format="HH:mm" style="width: 270px;font-size: 12px;margin: 5px 10px 5px 0;"></el-time-picker>
        <div><i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #1362FF;margin: 5px 10px 5px 0;cursor: pointer;" @click="addWeekTimeValue(item.weekTimeValue)"></i></div>
      </div>
    </div>
    <p class="add-time-line"><span @click="addTimeLine" style="cursor: pointer"><i class="el-icon-plus"></i>增加时段</span></p>
  </div>
</template>

<script>
  import {nError} from '../../utils/notice'

  export default {
    name: 'time-interval',
    props: {
      defaultLineIndex: {
        type: Array,
        default () {
          return [
            {
              weekDay: [],
              week: [
                {
                  key: '周一',
                  disabled: false
                },
                {
                  key: '周二',
                  disabled: false
                },
                {
                  key: '周三',
                  disabled: false
                },
                {
                  key: '周四',
                  disabled: false
                },
                {
                  key: '周五',
                  disabled: false
                },
                {
                  key: '周六',
                  disabled: false
                },
                {
                  key: '周日',
                  disabled: false
                }
              ],
              weekTimeValue: [
                {
                  key: ['00:00', '23:59']
                }
              ],
            }
          ]
        }
      },
    },
    data () {
      return {
        week: [
          {
            key: '周一',
            disabled: false
          },
          {
            key: '周二',
            disabled: false
          },
          {
            key: '周三',
            disabled: false
          },
          {
            key: '周四',
            disabled: false
          },
          {
            key: '周五',
            disabled: false
          },
          {
            key: '周六',
            disabled: false
          },
          {
            key: '周日',
            disabled: false
          }
        ],
        lineIndex: [
          {
            weekDay: [],
            week: [
              {
                key: '周一',
                disabled: false
              },
              {
                key: '周二',
                disabled: false
              },
              {
                key: '周三',
                disabled: false
              },
              {
                key: '周四',
                disabled: false
              },
              {
                key: '周五',
                disabled: false
              },
              {
                key: '周六',
                disabled: false
              },
              {
                key: '周日',
                disabled: false
              }
            ],
            weekTimeValue: [
              {
                key: ['00:00', '23:59']
              }
            ],
          }
        ],
      }
    },
    mounted () {
      setTimeout(() => {
        let arr = []
        this.defaultLineIndex.map(v => {
          let weekTimeValueArr = []
          v.weekTimeValue.map(weekTimeValue => {
            if (weekTimeValueArr.length === 0) {
              weekTimeValueArr.push(weekTimeValue)
            } else {
              let weekTimeValueState = true
              weekTimeValueArr.map(weekTimeValueArrValue => {
                if (weekTimeValue.key.join(',') === weekTimeValueArrValue.key.join(',')) {
                  weekTimeValueState = false
                }
              })
              if (weekTimeValueState) {
                weekTimeValueArr.push(weekTimeValue)
              }
            }
          })
          v.weekTimeValue = weekTimeValueArr
          if (arr.length === 0) {
            arr.push(v)
          } else {
            let state = true
            arr.map(arrVal => {
              if (v.weekDay.sort().join(',') === arrVal.weekDay.sort().join(',')) {
                state = false
              }
            })
            if (state) {
              arr.push(v)
            }
          }
        })
        this.lineIndex = arr
      }, 500)
    },
    methods: {
      addTimeLine () {
        let weekStr = ''
        this.lineIndex.map(lineIndex => {
          weekStr = weekStr + lineIndex.weekDay.join('')
        })
        if (weekStr.indexOf('周一') !== -1 && weekStr.indexOf('周二') !== -1 && weekStr.indexOf('周三') !== -1 && weekStr.indexOf('周四') !== -1 && weekStr.indexOf('周五') !== -1 && weekStr.indexOf('周六') !== -1 && weekStr.indexOf('周日') !== -1) {
          nError('一周时间已选择完成')
          return false
        }
        let newLine = {
          weekDay: [],
          week: [],
          weekTimeValue: [
            {
              key: ['00:00', '23:59']
            }
          ],
        }
        let theWeekCheck = []
        this.lineIndex.map(v => {
          v.weekDay.map(val => {
            theWeekCheck.push(val)
          })
        })
        let defaultWeek = [
          {
            key: '周一',
            disabled: false
          },
          {
            key: '周二',
            disabled: false
          },
          {
            key: '周三',
            disabled: false
          },
          {
            key: '周四',
            disabled: false
          },
          {
            key: '周五',
            disabled: false
          },
          {
            key: '周六',
            disabled: false
          },
          {
            key: '周日',
            disabled: false
          }
        ]

        defaultWeek.map(weekDefault => {
          theWeekCheck.map(weekCheck => {
            if (weekDefault.key === weekCheck) {
              weekDefault.disabled = true
            }
          })
        })

        newLine.week = defaultWeek
        this.lineIndex.push(newLine)
      },

      removeTimeLine (index) {
        this.lineIndex.splice(index, 1)
      },

      addWeekTimeValue (weekTimeValueArr) {
        weekTimeValueArr.push(
          {
            key: ['00:00', '23:59']
          }
        )
      },
    },
    watch: {
      defaultLineIndex (val) {
        setTimeout(() => {
          let arr = []
          this.defaultLineIndex.map(v => {
            let weekTimeValueArr = []
            v.weekTimeValue.map(weekTimeValue => {
              if (weekTimeValueArr.length === 0) {
                weekTimeValueArr.push(weekTimeValue)
              } else {
                let weekTimeValueState = true
                weekTimeValueArr.map(weekTimeValueArrValue => {
                  if (weekTimeValue.key.join(',') === weekTimeValueArrValue.key.join(',')) {
                    weekTimeValueState = false
                  }
                })
                if (weekTimeValueState) {
                  weekTimeValueArr.push(weekTimeValue)
                }
              }
            })
            v.weekTimeValue = weekTimeValueArr
            if (arr.length === 0) {
              arr.push(v)
            } else {
              let state = true
              arr.map(arrVal => {
                if (v.weekDay.sort().join(',') === arrVal.weekDay.sort().join(',')) {
                  state = false
                }
              })
              if (state) {
                arr.push(v)
              }
            }
          })
          this.lineIndex = arr
        }, 500)
      },
      lineIndex: {
        handler () {
          let allCheckWeekDay = []
          for (let i = 0; i < this.lineIndex.length; i++) {
            this.lineIndex[i].weekDay.map(v => {
              allCheckWeekDay.push(v)
              for (let j = 0; j < this.lineIndex.length; j++) {
                if (i !== j) {
                  this.lineIndex[j].week.map(lineIndexWeek => {
                    if (lineIndexWeek.key === v) {
                      lineIndexWeek.disabled = true
                    }
                  })
                }
              }
            })
          }
          for (let k = 0; k < this.lineIndex.length; k++) {
            this.lineIndex[k].week.map(v => {
              if (allCheckWeekDay.indexOf(v.key) === -1) {
                v.disabled = false
              }
            })
          }
          this.$emit('getAttendanceItemDurations', this.lineIndex)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .day-time-line {
    margin-bottom: 10px;
  }
  .add-time-line {
    color: #1362FF;
  }
</style>

<style lang="less">
  .timeInterval {
    max-height: 350px;
    padding-bottom: 10px;
    overflow-y: auto;
    .el-date-editor  {
      .el-range__close-icon {
        width: 20px !important;
      }
    }
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/WeekTime/timeInterval.vue